import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

const RevenueChart = ({ transactions }) => {
  // Group transactions by month
  const monthlyRevenue =
    transactions?.reduce((acc, t) => {
      const date = new Date(t.createdAt);
      const month = date.toLocaleString("default", { month: "short" });
      const year = date.getFullYear();
      const key = `${month} ${year}`;

      if (!acc[key]) acc[key] = 0;
      acc[key] += t.amount;
      return acc;
    }, {}) || {};

  // Convert to chart-friendly array
  const chartData = Object.entries(monthlyRevenue).map(([month, revenue]) => ({
    month,
    revenue,
  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis tickFormatter={(val) => `$${val}`} />
        <Tooltip formatter={(val) => [`$${val.toFixed(2)}`, "Revenue"]} />
        <Line
          type="monotone"
          dataKey="revenue"
          stroke="#007bff"
          strokeWidth={2}
          dot={{ r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RevenueChart;
